import { EnterpriseCustomizedMessagesV1NaptimeResource } from './__generated__/EnterpriseCustomizedMessagesV1';

class EnterpriseCustomizedMessages extends EnterpriseCustomizedMessagesV1NaptimeResource {
  static RESOURCE_NAME = 'enterpriseCustomizedMessages.v1' as const;
}

export default EnterpriseCustomizedMessages;
